module.exports = __webpack_public_path__ + "img/CRD520.a338522b.webp";